
import {Later} from 'utils/timers'
import {FilterContext} from 'mixins'
export default {
  mixins: [FilterContext.mixin],
  props: {
    items: {
      type: Array,
      default: () => [] 
    },
    title: {
      type: String,
      default: ''
    },
  },
  data(){
    return {
      search: '',
      chosens: new Set(),
      later: new Later(200)
    }
  },
  computed: {
    c_items(){
      return this.items.filter(item => item.toLowerCase().includes(this.search.toLowerCase()))
    },
  },
  watch: {
    async prev(){
      this.chosens.clear()
      this.prev.forEach(item => this.chosens.add(item))
      this.later.once(this.cleanSearch)
    },
    chosens:{
      handler() {
        this.next = Array.from(this.chosens)
      },
      deep: true
    }
  },
  beforeUnmount() {
    this.later.abort()
  },
  methods: {
    onChecked(item) {
      if (this.chosens.has(item)) {
        this.chosens.delete(item)
      } else {
        this.chosens.add(item)
      }
    },
    cleanSearch(){
      this.search = ''
    }
  }
}
